import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Modal,
  Paper
} from '@material-ui/core';

import ProductsDisplay from 'components/QuickSale/ProductsDisplay';
import PaymentDisplay from 'components/QuickSale/PaymentDisplay';
import SalesOrderInvoice from 'components/Invoices/SalesOrderInvoice';

import { setNewSODisplayId, clearNewSO, addSalesOrder } from 'redux/actions';

const mapStateToProps = (state) => ({
  newSalesOrder: state.newSalesOrder
});

const QuickSaleDisplay = (props) => {

  const printRef = useRef();

  const { displayId, customerId, soProducts, totalVat, total, paymentMethod } = props.newSalesOrder;

  const [openInvoiceModal, setOpenInvoiceModal] = useState(false);
  const [currSubTotal, setCurrSubTotal] = useState(0);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Sales Order Invoice"
  });

  const salesOrderCleanup = () => {
    props.clearNewSO();
    setOpenInvoiceModal(false);
    setCurrSubTotal(0);
  };

  const saveSalesOrder = (paymentInfo) => {

    const displayId = props.createSODisplayId();
    const newSalesOrder = {
      displayId,
      customerId,
      ...paymentInfo,
      products: soProducts.map(product => ({
        productId: product.productId,
        unitPrice: product.unitPrice,
        quantity: product.quantity
      }))
    };
    
    props.setNewSODisplayId(displayId);
    props.addSalesOrder(newSalesOrder, props.activeUserId, props.user.adminId);

    setOpenInvoiceModal(true);
  };

  const createInvoiceInfo = () => {
    const customerInfo = props.customers.find(customer => customer.id === customerId);
    return {
      displayId,
      customerName: customerInfo ? customerInfo.name : "",
      customerPhone: customerInfo ? customerInfo.phone : "",
      paymentDate: new Date(),
      subTotal: total - totalVat,
      taxTotal: totalVat,
      grandTotal: total,
      paymentMethod,
      products: soProducts
    }
  };

  return (
    <React.Fragment>
      <Box sx={{
          display: 'flex',
          flexDirection: 'row',
          height: '600px',
          backgroundColor: 'background.default'
        }}
      >
        <Box sx={{ flexBasis: '65%' }}>
          <ProductsDisplay
            products={props.products}
            soProducts={soProducts}
            currSubTotal={currSubTotal}
            setCurrSubTotal={setCurrSubTotal}
          />
        </Box>
        <Box sx={{ flexBasis: '35%' }}>
          <PaymentDisplay
            customers={props.customers}
            activeUserId={props.activeUserId}
            activeUserType={props.activeUserType}
            user={props.user}
            customerId={customerId}
            soProducts={soProducts}
            currSubTotal={currSubTotal}
            setCurrSubTotal={setCurrSubTotal}
            saveSalesOrder={saveSalesOrder}
            salesOrderCleanup={salesOrderCleanup}
            createCustomerDisplayId={props.createCustomerDisplayId}
          />
        </Box>
      </Box>
      { openInvoiceModal ?
      <Modal open={openInvoiceModal}>
        <Card>
          <CardHeader
            subheader="Please Review the Order."
            title="Print Invoice"
          />
          <Divider />
          <CardContent>
            <Box>
              <Paper
                style={{
                  overflow: 'auto',
                  maxHeight: 469
                }}
              >
                <SalesOrderInvoice
                  ref={printRef}
                  info={createInvoiceInfo()}
                  user={props.user}
                />
              </Paper>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  paddingTop: '1%'
                }}
              >
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handlePrint}
                >
                  Print Invoice
                </Button>
                <Button
                  color="primary"
                  onClick={salesOrderCleanup}
                >
                  Close
                </Button>
              </Box>
            </Box>
          </CardContent>
          <Divider />
        </Card>
      </Modal> : null }
    </React.Fragment>
  )
};

export default connect (mapStateToProps, {setNewSODisplayId, clearNewSO, addSalesOrder}) (QuickSaleDisplay);